export default "__VITE_ASSET__Dlm3753$__"